import * as React from 'react';

import {
  Colors,
  Breakpoint,
  Lang,
  Confetti,

  useDimensions,

  ContentContainer,
  LargeContainer,

  TextBlock,
} from '@bluecurrent/web-component-lib';

import Setup from '../../config/setup';

import Form from '../Sections/Form';

export default function ReserveForm(props) {
  const { i18n } = Lang.useTranslation();
  const size = useDimensions();

  const lang = Setup.PSEUDO ? 'en' : i18n.language;

  const contentContainerRef = React.useRef(0);

  const [width, setWidth] = React.useState('100%');

  const getWidth = () => {
    if (contentContainerRef.current?.clientWidth) {
      setWidth(contentContainerRef.current.clientWidth);
    }
  };

  React.useEffect(() => {
    getWidth();
  }, [width]);

  React.useEffect(() => {
    window.addEventListener('resize', getWidth);

    return () => {
      window.removeEventListener('resize', getWidth);
    };
  }, []);

  return (
    <>
      {
        size.width >= Breakpoint.xs && (
          <div
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              zIndex: -1,
              marginTop: size.width < Breakpoint.xxl
                ? size.width < 900
                  ? -100
                  : -275
                : -450,
              overflow: 'hidden',
            }}
          >
            <Confetti
              type="DotsPath"
              height={1000}
              width={1000}
              color={Colors.MEDIUM_WHITE}
              position="absolute"
              zIndex={-1}
              transform={`rotate(${size.width < 900 ? 100 : 0}deg)`}
              top={0}
              left={size.width < 900 ? -300 : -50}
            />
          </div>
        )
      }
      <section
        className="SectionForm"
        id="invest"
        style={{
          marginTop: 150,
          position: 'relative',
          zIndex: 1,
          overflow: 'hidden',
        }}
      >
        <LargeContainer>
          <div
            style={{
              backgroundColor: Colors.BLUE,
              height: 'auto',
              width: '100%',
              paddingTop: 60,
              paddingBottom: 60,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: size.width < 1440 ? 0 : 15,
              positon: 'relative',
            }}
          >
            <div
              style={{
                width: size.width >= Breakpoint.md && size.width < 1440 ? '70%' : width,
                backgroundColor: Colors.WHITE,
                paddingTop: size.width < Breakpoint.sm ? 30 : 50,
                paddingBottom: size.width < Breakpoint.sm ? 30 : 50,
                paddingLeft: size.width < Breakpoint.sm ? 15 : '8%',
                paddingRight: size.width < Breakpoint.sm ? 15 : '8%',
                borderRadius: 15,
                position: 'relative',
                zIndex: 1,
              }}
            >
              <div
                style={{
                  marginBottom: 30,
                }}
              >
                <TextBlock
                  title={{
                    content: props.content.title[lang],
                  }}
                  text={{
                    content: props.content.text[lang],
                    portableText: true,
                  }}
                />
              </div>
              <Form
                quickSelectText={props.quickSelectText}
                successContent={props.successContent}
              />
            </div>
            {
              size.width >= Breakpoint.xs && (
                <div
                  style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    marginTop: size.width < Breakpoint.xxl
                      ? size.width < 630 ? 850 : 700
                      : 400,
                    zIndex: 0,
                    overflow: 'hidden',
                  }}
                >
                  <Confetti
                    type="DotsPath"
                    height={1000}
                    width={1000}
                    color={Colors.WHITE}
                    position="absolute"
                    transform="scaleX(-1) rotate(20deg)"
                    right={size.width < Breakpoint.xxl ? -200 : -110}
                    opacity={0.5}
                  />
                </div>
              )
            }
          </div>
        </LargeContainer>
        <ContentContainer>
          <div
            ref={contentContainerRef}
            style={{
              width: '100%',
              height: 0,
            }}
          />
        </ContentContainer>
      </section>
    </>
  );
}
